<span class="polaris-thumb" [style.width.px]="size" [style.height.px]="size">
  <img class="polaris-thumb__image" [src]="image" alt="" />
  @if (quantity != null) {
    <span class="polaris-thumb__badge">{{ quantity }}</span>
  }
</span>
